import { useEffect, useState } from "react";
import { Youtube, Play, Trophy } from "lucide-react";
import { api } from "../lib/api";

const CHANNEL_URL = "https://www.youtube.com/channel/UCCCYavxof1TxG7dkyw8bVdA";

const FeaturedYouTube = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/social/featured", { params: { limit: 12 } }).then((r) => setItems(r.data || [])).catch(() => {});
  }, []);
  if (!items.length) return null;
  return (
    <section data-testid="featured-youtube" className="max-w-[1500px] mx-auto px-4 lg:px-8 my-10">
      <div className="flex items-end justify-between mb-4">
        <div>
          <div className="overline mb-1 text-[#FF0000]"><Youtube className="inline w-3.5 h-3.5 mr-1" /> Featured</div>
          <h2 className="font-heading text-xl font-extrabold uppercase">On our YouTube</h2>
          <p className="font-mono text-[11px] text-[#64748B] mt-0.5">Community clips published to the official OCE DOGS channel</p>
        </div>
        <a href={CHANNEL_URL} target="_blank" rel="noreferrer" data-testid="featured-yt-channel" className="text-sm font-stencil uppercase text-[#FF4D4D] hover:text-[#FF6B6B] shrink-0">Channel →</a>
      </div>
      <div className="flex gap-3 overflow-x-auto pb-3 snap-x scrollbar-thin">
        {items.map((v) => (
          <a key={v.video_id} data-testid={`featured-yt-${v.video_id}`} href={v.url} target="_blank" rel="noreferrer" className={`group shrink-0 w-[150px] sm:w-[160px] snap-start ${v.clip_of_week ? "w-[170px] sm:w-[186px]" : ""}`}>
            <div className={`relative aspect-[9/16] bg-[#0B0C0E] border overflow-hidden tactical-frame-sm transition-colors ${v.clip_of_week ? "border-[#FFD700] shadow-[0_0_16px_rgba(255,215,0,0.25)]" : "border-[#2A2E3D] group-hover:border-[#FF0000]"}`}>
              {v.clip_of_week && <div data-testid="clip-of-week-ribbon" className="absolute top-0 left-0 z-10 bg-[#FFD700] text-black font-stencil font-black uppercase text-[9px] px-2 py-0.5 flex items-center gap-1"><Trophy className="w-3 h-3" /> Clip of the Week</div>}
              <img src={v.thumbnail} alt={v.title} loading="lazy" decoding="async" className="w-full h-full object-cover" onError={(e) => { e.currentTarget.style.display = "none"; }} />
              <div className="absolute inset-0 flex items-center justify-center bg-black/30 opacity-0 group-hover:opacity-100 transition-opacity">
                <span className="w-11 h-11 rounded-full bg-[#FF0000] flex items-center justify-center"><Play className="w-5 h-5 text-white fill-white ml-0.5" /></span>
              </div>
            </div>
            <div className={`font-stencil text-xs mt-1.5 line-clamp-2 leading-tight ${v.clip_of_week ? "text-[#FFD700]" : "text-[#F1F5F9] group-hover:text-[#FF4D4D]"}`}>{v.title}</div>
            <div className="font-mono text-[10px] text-[#64748B] truncate">@{v.uploader}{v.views != null ? ` · ${v.views} views` : ""}</div>
          </a>
        ))}
      </div>
    </section>
  );
};

export default FeaturedYouTube;
